import { t } from "i18next";
import { z } from "zod";

import { FolderFileDocumentCode } from "src/core/constants/folder";
import { documentsUploadSchema } from "src/core/forms/folder/documentsUpload.schema";

export const missionLetterSchema = () => z.object({ documents: documentsUploadSchema(t) });
export type MissionLetterFormValues = z.infer<ReturnType<typeof missionLetterSchema>>;
export const defaultMissionLetterValues = (): MissionLetterFormValues => {
  return {
    documents: {
      [FolderFileDocumentCode.MISSION_LETTER]: {
        file: null,
        existing: false,
        fileId: undefined,
        fileName: undefined,
        expirationDate: undefined,
      },
    },
  };
};
